export enum VoiceMailGreetingPromptOption {
   Name = 'Name',
   Unavailable = 'Unavailable',
   Busy = 'Busy',
   Temporary = 'Temporary',
}
